import {RoomBaseApiService} from "./room.baseapi.service";
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class RoomInviteService extends RoomBaseApiService {
    async inviteByEmail(data) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/invites`, data)
            return new ResponseWrapper(response, response.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async checkInvitedEmail(params) {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/invites?email=${params.email}`)
            return new ResponseWrapper(response, response.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const roomInviteService = new RoomInviteService()